export default __webpack_public_path__ + "static/media/Hubano-2.266437a0.png";